// Key of Content Optimizer tab key in local storage
export const contentOptimizerLSTabKey = 'coTabKey';
export const contentOptimizerKeywordsTabKey = 'coKeywordsTabKey';
export const contentOptimizerBriefSubTabKey = 'briefTabKey';

export const ContentOptimizerQueueStatus = {
    NOT_STARTED: 'not_started',
    QUEUED: 'queued',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

export const FAILED_OPTIMIZER_TEXT =
    'Your Optimizer encountered an issue, likely due to insufficient keyword results. Please try again (no credit was charged) or contact support if it persists.';
